import { DataProvider } from "@acadia-ui/theme";

export default class CustomDataProvider extends DataProvider {
	doSearch(rows, searchQuery, searchIgnoreKeys) {
		const dateFormatter = new Intl.DateTimeFormat("en-US", { year: "numeric", month: "short", day: "2-digit" });
		return rows.filter((row, i) => {
			for (const key in row) {
				if (searchIgnoreKeys && searchIgnoreKeys.indexOf(key) !== -1) {
					continue;
				}

				const val = row[key];
				if (val) {
					if (typeof val === "string" && val.toLowerCase().indexOf(searchQuery.toLowerCase()) != -1) {
						return true;
					}

					if (val == searchQuery) {
						// NOTE: This needs to be "==" and not "===" so it can compare numbers to strings
						return true;
					}

					if (key === "formattedCreatedDate" || key === "formattedLastModifiedDate") {
						const d = dateFormatter.format(new Date(val))?.toLowerCase?.();
						if (d?.includes?.(searchQuery?.toLowerCase?.())) {
							return true;
						}
					}
				}
			}

			return false;
		});
	}
}
